import { people01, people02, people03, facebook, instagram, linkedin, twitter, airbnb, binance, coinbase, dropbox, send, shield, star  } from "../assets";
import {v1, v2, v3, v4, v5, v6, hand_holding, pawhand, pvet ,cat, chicks, hen, chick_pvet, pup, Gicheha, cow1, cow2, pruner1, pruner2, pruner3, pruner4, pruner7, pruner8, pruner9, pruner10} from "../assets"  
import * as RiIcons from "react-icons/ri"
import * as MdIcons from "react-icons/md"
import * as HiIcons from "react-icons/hi"
import * as AiIcons from "react-icons/ai"
import VetlineP1 from "../assets/New_Pvet/Products/P1.jpeg"
import VetlineP2 from "../assets/New_Pvet/Products/P2.jpeg"
import VetlineP3 from "../assets/New_Pvet/Products/P3.jpeg"
import VetlineP4 from "../assets/New_Pvet/Products/P4.jpeg"
import VetlineMain1 from "../assets/New_Pvet/Products/VetlineMain1.jpeg"
import VetlineMain2 from "../assets/New_Pvet/Products/VetlineMain2.jpeg"
import VetlineProbio from "../assets/New_Pvet/Products/PROBIO.jpeg"
import VetlineVetCPlus from "../assets/New_Pvet/Products/VET C Plus.jpeg"

export const navLinks = [
    {
      id: "home",
      title: "Home",
      link : "/"
    },
    {
      id: "about-us",
      title: "About Us",
      link : "/about",
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subnav: [
        {
          title: "Mission",
        },
        {
          title: "Vision"
        },
        {
          title: "Core Values"
        }
      ]
    },
    {
      id: "products",
      title: "Our Products",
      link : "/products"
    },
    {
      id: "services",
      title: "Our Services",
      link : "/services"
    },
    {
      id: "team",
      title: "Our Team",
      link : "/team"
    },
    {
        id: "contact",
        title: "Contact Us",
        link : "/contact",
        number: "+254765204349"
    },
  ];

export const contact = [
  {
    id: "contact",
    title: "Contact Us",
    number: "+254765204349"
  }
]

export const newContact = [
  {
    id: "email",
    title: "info@prunervet.com",
    icon: <HiIcons.HiOutlineMail style={{color: "white"}} className="md:w-[30px] md:h-[30px] w-[20px] h-[20px]" />
  },
  {
    id: "location",
    title: (
      <>
      Juja Shangwe Place, Muchatha, Juja, Kiambu
      <br />
      P. O. Box 708-01001, Kalimoni
      </>
    ),
    icon: <MdIcons.MdOutlineLocationOn style={{color: "white"}} className="md:w-[30px] md:h-[30px] w-[20px] h-[20px]" />
  }
]

export const socialMedia = [
    {
        id: "social-media-1",
        icon: instagram,
        link: "https://www.instagram.com/pruner_the_vet/",
    },
    {
        id: "social-media-2",
        icon: facebook,
        link: "https://www.facebook.com/",
    },
    {
        id: "social-media-3",
        icon: <AiIcons.AiFillYoutube />,
        link: "https://www.youtube.com/",
    },
];

export const Images = [
  {
    id: 0,
    img : pvet
  },
  {
    id: 1,
    img: cow1,
    words: (
      <>
        Welcome To
        <br />
        <p className="md:text-[50px] text-[40px]">Prunervet Centre</p>
        Ltd
      </>
    )
  },
  {
    id: 2,
    img: chicks,
    words: "We improve farm and livestock productivity by providing affordable solutions through optimal quality products, services and client support"
  },
  {
    id: 3,
    img: hen,
    words: "Creating food affluent societies"
  },
  {
    id: 4,
    img: cow2,
    words: "We are aiming at satisfaction and fulfilment to our esteemed customers"
  },
  {
    id: 5,
    img: pup,
    words: "To generate long term relationships with you"
  },
  {
    id: 6,
    img: cat,
  },
]

export const newImages = [
  {
    id: 1,
    img: pruner1,
  },
  {
    id: 2,
    img: v1
  },
  {
    id: 3,
    img: v2,
  },
  {
    id: 4,
    img: v3,
  },
  {
    id: 5,
    img: v4,
  },

  {
    id: 6,
    img: v5,
  },
  {
    id: 7,
    img: v6,
  }
]

export const newImages2 = [
  {
    id: 1,
    img: pawhand
  }
]

export const Work_Force = [
  {
    id: 1,
    img: Gicheha,
    words: "Mr. Gicheha"
  }
]

export const About = [
  {
    id: 1,
    header:"Mission",
    statement: "To improve farm and livestock productivity by providing affordable solutions through optimal quality products, services and client support."
  },
  {
    id : 2,
    header : "Vision",
    statement: "To create food affluent societies."
  },
  {
    id: 3,
    header: "Core Values",
    values: [
      {
        id: 1,
        value: "Customer Focus",
        aim: "Satisfaction and fulfilment"
      },
      {
        id: 2,
        value: "Essence",
        aim: "Indispensable quality"
      },
      {
        id: 3,
        value: "Integrity",
        aim: "Consistency and uncompromising"
      },
      {
        id: 4,
        value: "Flexibility",
        aim: "Dynamism and willingness to change"
      }      
    ]
  },
  {
    id: 4,
    header: "Objective",
    statement1: `Established in 2015 in Juja Sub County, Kenya, Prunervet Center is committed to delivering affordable and fair-priced veterinary services, products, and support to our clients. 
    By ensuring operational efficiency and targeting specific market segments - including agrovets, individual farmers, veterinary professionals, and walk-in customers - we can offer our services at affordable prices. 
    This focused approach further enhances our efficiency, helping us sidestep cash flow issues often linked to credit payments.`,
    statement: `Prunervet Center is committed to delivering affordable and fair-priced products and veterinary services while offering our clients optimal support in their agribusinesses. 
    Our commerce model covers B2B (Business to business), B2C (Business to Consumer) and DTC (Direct to consumer). Our primary market segments include agrovets (veterinary pharmacies), individual farmers, corporate farms, veterinary professionals, and walk-in customers to whom we offer our products and services at affordable prices and rates. 
    This focused approach enhances our efficiency and optimal support to our customers.`
  }
]

export const our_services = [
  {
    id: "Products",
    catchphrase: "Your One-Stop Hub for Comprehensive Veterinary Solutions",
    statement: [
      {
        message: 
        <>
        <span className="font-semibold">Prunervet Centre Limited</span> proudly offers a comprehensive suite of <span className="font-semibold">veterinary products and services</span>. 
        Our commitment to continuous development and ambition to remain at the forefront of the veterinary field allows us to meet the diverse needs of our clients. 
        We leverage our extensive network of suppliers and veterinary partners to ensure the highest quality solutions and services are always within our clients' reach. 
        Striving to be an indispensable resource, we persistently innovate, making Prunervet Centre the ideal choice for all veterinary demands.
        </>
      },
    ]
  }
]

export const home_services = [
  {
    id: "Home_Services",
    statement: [
      {
        id: 1,
        words: `Prunervet Centre is your comprehensive solution for veterinary services, offering a wide range of products from our extensive supplier and partner networks.`
      },
      {
        id: 2,
        words: `Our focus lies in robust poultry health management through meticulous vaccination programs, designed to optimize each bird's immunity and resistance to infections. `
      },
      {
        id: 3,
        words: `We provide a tailored vaccination schedule based on your system and disease prevalence, assist with vaccine supply, and offer an organized calendar for seamless execution.`
      },
      {
        id: 4,
        words: `Choose Prunervet Centre, your one-stop hub for veterinary excellence.`
      },
    ]
  }
]

export const Vaccination = [
  {
    id: 1,
    header: "Importance",
    statement: `Vaccination plays an important 
    part in the health management of 
    the poultry flock, by triggering or 
    boosting the chicken immune 
    system to produce antibodies that 
    in turn fight the invading causal 
    organisms`
  },
  {
    id:2,
    header: "Poultry Vaccination Objectives",
    objectives: [
      {
        id: 1,
        statement: "That each bird is to receive a proper dose"
      },
      {
        id: 2,
        statement: " Confer to each bird the ability to resist a particular infection."
      },
      {
        id: 3,
        statement: " Prevention of the disease challenge risk getting into the farm"
      }
    ]
  },
  {
    id : 3,
    header: "Vaccination Program",
    statement : `Based on diseases prevalence and your 
    production system, we build and modify 
    you a vaccination program.`
  },
  {
    id: 4,
    header: "Vaccination Management",
    statement: `Vaccine supply while mapping a calender
    with reminders to aid in effectively 
    executing the program.`
  },
  {
    id: 5,
    header: "Vaccine Administration",
    statement: `We offer vaccine application training and 
    supervisory services.`
  },
  {
    id: 6,
    header: "Vaccination Monitoring",
    statement: `Following vaccination, we can evaluate the efficiency and effectiveness of the vaccination program.`
  }
]

export const our_team = [
  {
    id: "Team",
    catchphrase: "Combining Compassion with Expertise for Superior Care.",
    statement: (
    <>
      Prunervet Centre Limited thrives by employing friendly and knowledgeable personnel 
      which along with our great prices, will drive the repeat business that we rely upon.
      Prunervet Centre is led by a Veterinary Medicine graduate with vast experience in commercial and technical aspects of the veterinary field. 
      Their expertise spans pharmacology, biology, equipment, nutrition, and extension services in Kenya's veterinary industry.
    </>
    )

  }
]

export const Service_Scope = [
  {
    id: "Farm Visits Consultancy",
    purpose: [
      {
        id: "a",
        statement: "To conduct thorough audits of your farm's animal husbandry practices, biosecurity measures, disinfection protocols, and disease management programs"
      },
      {
        id : "b",
        statement: "Identify potential gaps and provide you with actionable recommendations to enhance the overall animal welfare and health management strategies."
      }
    ]
  },
  {
    id: "Biosecurity Audits",
    purpose: [
      {
        id : "a",
        statement : "Review and evaluate the current biosecurity practices on your farm."
      },
      {
        id : "b",
        statement : "Assess the risk factors associated with disease transmission and spread."
      },
      {
        id : "c",
        statement : "Suggest improvements to prevent and control disease outbreaks."
      },
      {
        id : "d",
        statement : "d.	Provide guidance on biosecurity protocols for incoming animals and visitors."
      }
    ]
  },
  {
    id : "Pest and parasite control audits",
    purpose : [
      {
        id : "a",
        statement : "Identification of pest and parasite issues."
      },
      {
        id : "b",
        statement : "Assessment of current control measures."
      },
      {
        id : "c",
        statement : "Risk analysis"
      },
      {
        id : "d",
        statement : "Recommendation for improvement."
      },
    ]
  },
  {
    id : "Vaccination Audits (Poultry)",
    purpose : [
      {
        id : "a",
        statement : "Analyze current vaccination program in place."
      },
      {
        id : "b",
        statement : "Assess the vaccine efficacy and coverage."
      },
      {
        id : "c",
        statement : "Provide guidance on the timing and appropriate vaccines for specific livestock populations."
      },
      {
        id : "d",
        statement : "Develop a customized vaccination schedule for optimal disease prevention."
      },
    ]
  },
  {
    id : "Confidentiality",
    purpose : [
      {
        id : "a",
        statement : `We guarantee utmost confidentiality for all data gathered during farm visits and consultations.
        Our team members will sign Non-Disclosure Agreements to safeguard your farm's sensitive information.`
      }
    ]
  }
]

export const product_details = [
  {
    id : "heading",
    statement : `As a veterinary wholesale and retail pharmacy, we offer a range of products tailored to the needs of livestock farmers, pet owners, and veterinary professionals.`
  },
  {
    id : "Product Services",
    examples : [
      {
        id : "Animal Health Products",
        statement : "We stock a wide variety of livestock and pet health products, classified under Pharm/Drugs, Feeds & Equipment that include but not limited to animal feeds, supplements, equipment,  vaccines, and preventive medications like flea and tick treatments."
      },
      {
        id : "Veterinary Prescription Management",
        statement : "We work closely with veterinary professionals and veterinary clinics to manage prescription orders and ensure seamless communication between the our retail veterinary pharmacy and the veterinarian."
      },
      {
        id : "Product Delivery",
        statement : "We offer home delivery services to livestock and pet owners who may have difficulty visiting the veterinary pharmarcy in person."
      },
      {
        id : "Dispense of veterinary prescriptions",
        statement : "Done for various medications, including antibiotics, anti-parasitics, and more."
      },
      {
        id : "Animal feeds",
        statement : "Supply of specialized animal diets recommended for livestock and pets with specific production and health conditions."
      },
      {
        id : "Feed compounding",
        statement : "Prepare custom formulations of animal feed when standard commercially available options are not suitable for a specific livestock needs."
      },
      {
        id : "Veterinary Medical Supplies",
        statement : "Provide animal equipments and supplies, including feeders, restrainers, syringes, and other items used in livestock production and veterinary care."
      },
      {
        id : "Pet Grooming and Hygiene Products",
        statement : "We offer a selection of grooming and hygiene products."
      },
      {
        id : "Health and Wellness Consultations",
        statement : "We employ knowledgeable staff who can offer advice and guidance on livestock and pet health and wellness, including nutrition, and preventive care."
      },
      {
        id : "Medication Counseling",
        statement : "Educate livestock farmers and pet owners on how to administer medications properly and discuss potential side effects or interactions with other medications."
      },
      {
        id : "Collaboration with veterinary paraprofessionals",
        statement : "Established partnerships with local paravets and offer promotional events or workshops to strengthen ties within the livestock production and pet care community."
      }
    ]
  },
  {
    id : "footer",
    statement : `As a veterinary pharmacy, we have complied with all relevant laws and regulations governing the dispensing of veterinary medications. 
    We have qualified staff trained as veterinary professionals to ensure the safety and well-being of the animals and clients in our care.`
  }
]

export const VETLINES_PRODUCTS = [
  {
    id: "product-1",
    name: "AD3 EK+C",
    description:
      "A liquid vitamin supplement containing Vitamins A, D3, E, K, and C to support calcium–phosphorus metabolism, strengthen immunity, enhance egg production, and promote reproductive health.",
    indications: [
      "Ideal during and after administration of injectable vaccines.",
      "Supports pullets transitioning into lay to build calcium reserves.",
      "Helps improve eggshell quality and overall egg quality.",
      "Supports immunity and bone health.",
    ],
    dosage: "1 ml per 4 litres of drinking water.",
    packs: "Available in 250mls, 500mls and 1 liter packs.",
    tagline:
      "Give your flock the nutritional support it needs for healthier birds and better egg quality!",
    image: VetlineP1,
  },
  {
    id: "product-2",
    name: "AMINO TECH",
    description:
      "A powerful liquid amino-vitamin supplement combining up to 16 amino acids, including essential amino acids such as Lysine, Methionine, Threonine, and Tyrosine, with Vitamins A, B-complex, D, E, and K to support growth, metabolism, and optimal performance.",
    indications: [
      "Chick Placement: Supports early growth and development.",
      "Start of Lay: Helps meet nutritional demands during the transition into egg production.",
      "Improved Egg Size: Supports egg size and production performance.",
      "Broiler Performance: Helps promote weight gain and overall growth.",
      "Nutritional Support: Supports metabolism, tissue development, and general flock health.",
    ],
    dosage: "1 ml per 4 litres of drinking water.",
    packs: "Available in 250mls, 500mls and 1 liter packs.",
    tagline: "Better growth. Bigger eggs. Improved flock performance!",
    image: VetlineP2,
  },
  {
    id: "product-3",
    name: "VET E SEL",
    description:
      "A liquid supplement enriched with Vitamin E, essential minerals, and supportive additives to help protect cells, support immune function, and promote reproductive health in poultry.",
    indications: [
      "Immune Support: Helps support birds during periods of illness, stress, and vaccination.",
      "Nervous System Support: Helps prevent nutritional encephalomalacia, commonly known as crazy chick disease, when associated with Vitamin E deficiency.",
      "Improved Fertility: Supports reproductive health and egg fertility in breeding birds.",
      "Better Hatchability: Helps support embryo development and hatchability.",
      "Cell Protection: Helps protect cells against oxidative damage.",
    ],
    dosage: "1 ml per 1 litre of drinking water.",
    packs: "Available in 250mls, 500mls & 1 liter packs.",
    tagline:
      "Support your flock through stress, strengthen reproductive performance, and give your chicks a better start! 🐣🐓",
    image: VetlineP3,
  },
  {
    id: "product-4",
    name: "AD3 COMBAT",
    description:
      "A liquid supplement combining Vitamins A and D3 with the natural benefits of Mint, Cinnamon, Lemon, and Garlic to support calcium–phosphorus metabolism, bone development, immunity, growth, and tissue repair.",
    indications: [
      "Supports healthy bone growth and development.",
      "Helps strengthen immune function.",
      "Supports respiratory health during periods of stress.",
      "Ideal during respiratory distress and around NCD + IB vaccination.",
      "Promotes growth and overall flock performance.",
    ],
    dosage: "1 ml per 5 litres of drinking water.",
    packs: "Available in 250mls, 500mls and 1 liter packs.",
    tagline: "Support Growth, Immunity & Respiratory Health!",
    image: VetlineP4,
  },
  {
    id: "product-5",
    name: "PROBIO",
    description:
      "A powdered multi-strain probiotic containing Lactobacillus and Pediococcus, enriched with Dextrose, Yeast Extract, Sodium Chloride, and Maltodextrin to support gut health, appetite, and feed conversion efficiency (FCR).",
    indications: [
      "Excellent Chick Start: Supports early gut development and healthy growth.",
      "Gut Health: Helps maintain a balanced intestinal microflora.",
      "Better FCR: Supports efficient feed utilization and flock performance.",
      "Improved Appetite: Helps support feed intake and digestive function.",
      "Antibiotic-Free Production: Supports gut health as part of responsible antibiotic-free poultry management.",
      "Post-Antibiotic Recovery: Helps restore a healthy gut microbial balance following antibiotic therapy.",
    ],
    dosage: "1 g per 5 litres of drinking water.",
    packs: "Available in 100g, 250g, 500g & 1kg packs.",
    tagline: "Start strong. Keep the gut healthy. Grow better birds! 🐥🐓",
    image: VetlineProbio,
  },
  {
    id: "product-6",
    name: "VET C PLUS",
    description:
      "A powdered nutritional supplement containing Vitamin C, Vitamin K, and Lysine to support immune function, nervous system health, and iron (Fe) absorption in poultry.",
    indications: [
      "Heat Stress Support: Helps birds cope with high temperatures and associated stress.",
      "Immune Support: Helps maintain normal immune function during periods of stress.",
      "Vitamin C Support: Helps address Vitamin C deficiency and supports antioxidant protection.",
      "Iron Absorption: Helps enhance iron absorption, supporting normal blood formation.",
      "Nervous System Support: Provides nutritional support for normal body functions.",
      "Environmental Stress: Ideal during periods of environmental stress and challenging weather conditions.",
    ],
    dosage: "1 g per 1 litre of drinking water.",
    packs: "Available in 100g, 250g, 500g & 1kg packs.",
    tagline: "Beat Heat Stress. Boost Immunity. Support Recovery!",
    image: VetlineVetCPlus,
  },
] 

export const VETLINES_SECTION = {
  title: "Polish Poultry Expertise Is Now in Kenya",
  subtitle: "Healthier birds. Better performance. More profit.",
  description:
    "Poland is Europe’s leading poultry meat producer — and now, Kenyan poultry farmers can access expertise from this world-class industry.",
  brand: "Vetlines",
  origin: "Poland",
  exportedTo: "23 countries worldwide",
  distributedBy: "Prunervet Centre Ltd",
  benefits: [
    "Stronger immunity",
    "Better gut health & nutrition",
    "Respiratory health support",
    "Reproductive performance",
    "Improved flock productivity",
  ],
  tagline: "VETLINES — HEALTH BY NATURE.",
  image: VetlineMain1,
  cta: {
    text: "Call / WhatsApp",
    phone: "0790 487 883",
  },
} 

export const VETLINES_REPRESENTATIVE = {
  title: "Local Technical Representative & Authorized Importer",
  description:
    "We are the Local Technical Representative (LTR) and authorized importer of VETLINES Poland products in our market. We are committed to supporting the registration, regulatory compliance, importation, and distribution of VETLINES Poland’s veterinary products.",
  brand: "VETLINES",
  country: "Poland",
  image:VetlineMain2,
  website: "https://vetlines.pl/", 
} 
